import './header.scss';
import MmenuLight from 'mmenu-light';

export default async () => {
	$( '.header__menu-list > li > .header__menu-subitems' ).parent( 'li' ).addClass( 'has-children' );

	if ( $( '.banner' ).length ) {
		$( '.header' ).addClass( 'header--dark' );
	}

	const menuHolder = document.querySelector( '#nav' );

	if ( menuHolder ) {
		const menu = new MmenuLight( menuHolder, '(max-width: 1023px)', );

		menu.navigation( {
			selected: 'is-active',
			title: 'Menu',
			theme: 'dark',
		} );

		const drawer = menu.offcanvas( {
			position: 'left',
		} );

		document.querySelector( 'a[href="#nav"]' ).addEventListener( 'click', ( event ) => {
			event.preventDefault();
			drawer.open();
		} );
	}

	$( '.header__search' ).click( function ( e ) {
		e.preventDefault();
		$( '.header__search-popup' ).fadeIn();
		$( 'body' ).addClass( 'body-hidden' );
	} );

	$( '.header__close' ).click( function ( e ) {
		e.preventDefault();
		$( '.header__search-popup' ).fadeOut();
		$( 'body' ).removeClass( 'body-hidden' );
	} );

	$( '.js-toggle-menu' ).click( function ( e ) {
		e.preventDefault();
		$( 'body' ).toggleClass( 'is-menu-open' );
	} );

	$( '.header__menu > ul > li > ul, .header__menu > ul > li > ul > li > ul' ).parent( 'li' ).addClass( 'has-children' );

	$( '.header__menu > ul > .has-children > a' ).append().after( '<span class=\'header__arrow hide-for-large js-menu-toggle\'><i class=\'icon-dropdown\'></i></span>' );

	$( '.js-menu-toggle' ).click( function ( e ) {
		e.preventDefault();

		let $this = $( this );

		if ( $this.hasClass( 'is-active' ) ) {
			$this.removeClass( 'is-active' );
			$this.next().slideUp( 350 );
		} else {
			$this.parent().parent().find( '.js-menu-toggle' ).removeClass( 'is-active' );
			$this.parent().parent().find( '.has-children ul' ).slideUp( 350 );
			$this.toggleClass( 'is-active' );
			$this.next().slideToggle( 350 );
		}
	} );
};
